import { Reveal } from "./Reveal";
import { Coffee, Brush, Flame, Gift } from "lucide-react";

const ICONS = [Brush, Coffee, Flame, Gift];

const STEPS = [
  {
    num: "01",
    icon: Brush,
    title: "Choisissez votre pièce",
    text: "Tasses, bols, assiettes, vases, figurines… Un large assortiment de pièces brutes en faïence n'attend que votre imagination. Chaque pièce affiche son prix, tout est inclus.",
  },
  {
    num: "02",
    icon: Coffee,
    title: "Peignez & dégustez",
    text: "Installez-vous confortablement : peintures, pochoirs, éponges et pinceaux sont à disposition. Pendant ce temps, on vous sert un espresso de torréfacteur local ou un latte gourmand et une pâtisserie.",
  },
  {
    num: "03",
    icon: Flame,
    title: "Nous émaillons & cuisons",
    text: "Vous repartez léger : nous appliquons l'émail transparent puis cuisson votre pièce à 1000°C dans notre four. Le résultat : une finition brillante, durable et adaptée au contact alimentaire.",
  },
  {
    num: "04",
    icon: Gift,
    title: "Récupérez votre œuvre",
    text: "Sous 2 semaines, votre création est prête. On vous prévient, vous passez la chercher — et pourquoi pas en profiter pour réserver l'atelier suivant.",
  },
];

export default function AtelierSteps({ content }) {
  const steps = (content?.steps?.length === 4 ? content.steps : STEPS).map((s, i) => ({
    ...s,
    icon: ICONS[i],
    num: `0${i + 1}`,
  }));
  return (
    <section id="atelier" data-testid="atelier-section" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal className="lg:col-span-7">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#C85A32] mb-4">Le déroulé d'un atelier</p>
            <h2 className="font-display tracking-tight text-[#201815] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              2h15 pour créer,
              <br />
              <span className="italic text-[#C85A32]">zéro expérience requise.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5 flex items-end">
            <div>
              <h3 className="text-base md:text-lg font-semibold text-[#201815] mb-2">{content?.about_title || "Un lieu pour ralentir"}</h3>
              <p className="text-[#5C4E48] leading-relaxed text-base">
                {content?.about_text ||
                  "Un lieu où l'on prend le temps : on choisit sa pièce, on la peint à son rythme autour d'un café ou d'un thé, dans une ambiance conviviale au cœur d'Auch. Aucune expérience requise : juste l'envie de créer."}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {steps.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08}>
              <article
                data-testid={`atelier-step-${step.num}`}
                className={`group relative overflow-hidden rounded-2xl border border-[#E5DCD3] p-8 md:p-10 h-full transition-colors duration-500 hover:border-[#C85A32]/40 ${
                  i % 3 === 0 ? "bg-white" : "bg-[#F4EFEA]"
                }`}
              >
                <span className="absolute -top-4 -right-2 font-display italic text-[7rem] leading-none text-[#C85A32]/10 select-none transition-transform duration-700 group-hover:scale-110">
                  {step.num}
                </span>
                <div className="relative">
                  <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#C85A32]/10 text-[#C85A32] transition-colors duration-500 group-hover:bg-[#C85A32] group-hover:text-[#FBF8F3]">
                    <step.icon size={20} />
                  </div>
                  <p className="font-mono-brand text-xs text-[#C85A32] mb-2">Chapitre {step.num}</p>
                  <h3 className="font-display text-2xl text-[#201815] mb-3">{step.title}</h3>
                  <p className="text-[#5C4E48] leading-relaxed text-sm sm:text-base">{step.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
